import MultiGrid, {PropsMultiGrid} from './MultiGrid'
export {MultiGrid, PropsMultiGrid}
